import React from "react";
import { useState } from "react";
import Footer from "components/Layout/Footer";
import LayoutWrapper from "components/Layout/Wrapper";
import { NavBar, Header } from "./components/";
import { SUBPATHS } from "./routes";
import styled from "styled-components";
import RequestsSwiper from "./requests-swiper";
import ChatBrowser from "./chat-browser";
import { mapToModel } from "./utils";
import { parseConnections } from "datamodel/Inbox/utils";
import { chain, get, mapValues, shake, isEmpty } from "radash";
import { translate } from "base/shared/Localization";
import { fetchDataForInbox } from "./hooks";

const model = {
  id: "connection.id",
  matchesStatusLabel: "enquiry.room.matches_status_label",
  hasBadiGold: "enquiry.room.premium_plan",
  payToMatchRequired: "enquiry.pay_to_match_required",
  user: {
    name: "enquiry.user.first_name",
    picture: "enquiry.user.cover_picture.width_500_url",
    picture_small: "enquiry.user.cover_picture.width_27_url",
    member_since: "enquiry.user.metrics.member_since",
    last_active: "enquiry.user.metrics.last_connection",
    tags: chain(
      (obj) => get(obj, "enquiry.user.tags"),
      (tags) =>
        mapValues(tags, (entries, tagCategoryKey) => ({
          key: tagCategoryKey,
          title: translate(
            `profile.form.fields.tags.category.${tagCategoryKey}.name`,
          ),
          iconSrc: `/assets/icons/icon-${tagCategoryKey}.svg`,
          iconAlt: tagCategoryKey,
          entries,
        })),
      (tags) => shake(tags, ({ entries }) => isEmpty(entries)),
    ),
  },
  room: {
    id: "enquiry.room.id",
    title: "enquiry.room.title",
    price: "enquiry.room.monthly_price.price",
    currency: "enquiry.room.monthly_price.currency",
    address: "enquiry.room.address",
    availableFrom: "enquiry.room.available_from",
    minimumStay: "enquiry.room.min_days",
  },
  nextStep: "connection.next_step",
};

const Container = styled.div`
  margin: 0px 200px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const isPath = (matchee, matchingPath) =>
  typeof matchingPath != "undefined" && matchee == matchingPath;

const InboxV2 = ({ params: { path }, location, router, token }) => {
  const [currentRequestIndex, setCurrentRequestIndex] = useState(0);
  const { requests, chats } = fetchDataForInbox(token);
  const requestsModel = requests.isLoaded
    ? requests.data.map((request) => mapToModel(model, request))
    : [];
  const chatsModel = chats.isLoaded ? parseConnections(chats.data) : [];

  const nextRequest = () => {
    setCurrentRequestIndex((currentRequestIndex + 1) % requestsModel.length);
  };

  const previousRequest = () => {
    setCurrentRequestIndex((currentRequestIndex - 1) % requestsModel.length);
  };

  const currentRequest = requestsModel[currentRequestIndex];

  return (
    <LayoutWrapper footer={<Footer campaign="inbox_footer" />}>
      <Container>
        <Header>Inbox</Header>
        <NavBar
          requestsCount={requestsModel.length}
          chatsCount={chatsModel.length}
        />
        {isPath(SUBPATHS.REQUESTS, path) && Boolean(currentRequest) && (
          <RequestsSwiper
            nextRequest={nextRequest}
            previousRequest={previousRequest}
            currentConnection={currentRequest}
          />
        )}
        {isPath(SUBPATHS.CHATS, path) && chatsModel.length && (
          <ChatBrowser
            connections={chatsModel}
            location={location}
            router={router}
          />
        )}
      </Container>
    </LayoutWrapper>
  );
};

export default InboxV2;
